// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../../_common/common.utils';
import AddMemberActionType from './add-member.types';

const INITIAL_STATE = {
	// Get Exists Member Details
	getExistsMemberDetailsResponse: null,
	getExistsMemberDetailsArr: [],
	// Fetch Member Data
	fetchMemberDataResp: null,
	fetchMemberDataArr: [],
	// Member Mandatory
	memberMandatoryResp: null,
	memberMandatoryArr: [],
	// Check Mandatory Fields
	checkMandatoryFieldsData: [],
	checkMandatoryFieldsResp: null,
	// Fetch Add Member List
	fetchAddMemberListResp: null,
	fetchAddMemberListArr: [],
	// Export Member List
	exportMemberListResp: null,
	exportMemberListArr: [],
	// Delete Member
	deleteMemberResp: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET MEMBER DETAILS START *********************** */
		case AddMemberActionType.GET_MEMBER_DETAILS_SUCCESS:
			return {
				...state,
				getExistsMemberDetailsResponse: action.payload,
				getExistsMemberDetailsArr: docodeHexResponse(
					action.payload,
					'MemberProfileDetails',
				),
			};

		case AddMemberActionType.GET_MEMBER_DETAILS_FAILURE:
			return { ...state, getExistsMemberDetailsResponse: action.payload };

		case AddMemberActionType.GET_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, getExistsMemberDetailsResponse: null };
		/** ***************** GET MEMBER DETAILS END *********************** */

		/** ***************** FETCH PARTICULAR MEMBER DETAILS START *********************** */
		case AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_SUCCESS:
			return {
				...state,
				fetchMemberDataResp: action.payload,
				fetchMemberDataArr: docodeHexResponse(action.payload, 'FetchMemberDataKey'),
			};

		case AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_FAILURE:
			return { ...state, fetchMemberDataResp: action.payload };

		case AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchMemberDataResp: null, fetchMemberDataArr: [] };
		/** ***************** FETCH PARTICULAR MEMBER DETAILS END *********************** */

		/** ***************** GET MEMBER MANDATORY FIELDS START *********************** */
		case AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_SUCCESS:
			return {
				...state,
				memberMandatoryResp: action.payload,
				memberMandatoryArr: docodeHexResponse(action.payload, 'MemberMandatoryDetailskey'),
			};

		case AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_FAILURE:
			return { ...state, memberMandatoryResp: action.payload };

		case AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_RESPONSE_CHANGED:
			return { ...state, memberMandatoryResp: null };
		/** ***************** GET MEMBER MANDATORY FIELDS END *********************** */

		/** ***************** CHECK ALL MANDATORY FIELDS START *********************** */
		case AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_SUCCESS:
			return {
				...state,
				checkMandatoryFieldsResp: action.payload,
				checkMandatoryFieldsData: docodeHexResponse(action.payload, 'MemberMandatoryKey'),
			};

		case AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_FAILURE:
			return { ...state, checkMandatoryFieldsResp: action.payload };

		case AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_CHANGED:
			return { ...state, checkMandatoryFieldsResp: null };
		/** ***************** CHECK ALL MANDATORY FIELDS END *********************** */

		/** ***************** FETCH ADD MEMBER LIST START *********************** */
		case AddMemberActionType.FETCH_ADD_MEMBER_LIST_SUCCESS:
			return {
				...state,
				fetchAddMemberListResp: action.payload,
				fetchAddMemberListArr: docodeHexResponse(action.payload, 'MemberDetailsKey'),
			};

		case AddMemberActionType.FETCH_ADD_MEMBER_LIST_FAILURE:
			return { ...state, fetchAddMemberListResp: action.payload, fetchAddMemberListArr: [] };

		case AddMemberActionType.FETCH_ADD_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAddMemberListResp: null };
		/** ***************** FETCH ADD MEMBER LIST END *********************** */

		/** ***************** EXPORT MEMBER LIST START *********************** */
		case AddMemberActionType.EXPORT_MEMBER_LIST_SUCCESS:
			return {
				...state,
				exportMemberListResp: action.payload,
				exportMemberListArr: docodeHexResponse(action.payload, 'AllMemberReportExcelKey'),
			};

		case AddMemberActionType.EXPORT_MEMBER_LIST_FAILURE:
			return { ...state, exportMemberListResp: action.payload };

		case AddMemberActionType.EXPORT_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, exportMemberListResp: null };
		/** ***************** EXPORT MEMBER LIST END *********************** */

		/** ***************** DELETE MEMBER START *********************** */
		case AddMemberActionType.DELETE_MEMBER_SUCCESS:
			return {
				...state,
				deleteMemberResp: action.payload,
			};

		case AddMemberActionType.DELETE_MEMBER_FAILURE:
			return { ...state, deleteMemberResp: action.payload };

		case AddMemberActionType.DELETE_MEMBER_RESPONSE_CHANGED:
			return { ...state, deleteMemberResp: null };
		/** ***************** DELETE MEMBER END *********************** */
		default:
			return state;
	}
};
